export default __webpack_public_path__ + "static/1735808435-64914649-130x130-anthony-m-0bbbca9a43f6d179799d7ccf46e1e857.jpg";